/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import axios from 'axios'
import createAsyncMutation from '../../utils/generators'

// Initial state
const state = {
  token: localStorage.getItem('token') || null,
  status: null,
  error: null
}

// Getters
const getters = {
  isAuthenticated: state => !!state.token,
  authLoading: state => state.status === 'loading',
  authStatus: state => state.status,
  authError: state => state.error
}

// Mutations
const mutations = {
  AUTHENTICATE_PENDING: state => {
    state.error = null
    state.status = 'loading'
  },
  AUTHENTICATE_SUCCESS: (state, response) => {
    state.error = null
    state.status = 'success'
    state.token = response.token
  },
  AUTHENTICATE_FAILURE: (state, error) => {
    state.status = 'error'
    // TODO: Pending API error handling changes
    state.error = error ? error.data.non_field_errors[0] : 'An unknown error occurred'
  },
  LOGOUT: state => {
    state.error = null
    state.token = null
  }
}

// Actions
const actions = {
  authenticate: ({ dispatch, rootState }, user) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.auth}`
    const mutationTypes = createAsyncMutation('AUTHENTICATE')
    return dispatch('post', { url, mutationTypes, data: user })
      .then(response => {
        const token = response.token
        localStorage.setItem('token', token)
        // Set axios default header
        axios.defaults.headers.common.Authorization = `Token ${token}`
        dispatch('getUser')
        return response
      })
      .catch(error => {
        localStorage.removeItem('token')
        return Promise.reject(error)
      })
  },
  logout: ({ commit }) =>
    new Promise((resolve, reject) => {
      try {
        commit('LOGOUT')
        commit('CLEAR_CURRENT_USER')
        localStorage.removeItem('token')
        // Remove axios default header
        delete axios.defaults.headers.common.Authorization
        resolve()
      } catch (error) {
        reject(error)
      }
    })
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js